import { RouterProvider } from "react-router-dom";
import { AppProviders } from "src/app/providers";
import { returnAfterSignIn, router } from "src/app/router";

/**
 * Root shell: auth, theme, data router. Mirrors insights-home's
 * src/app/App.tsx (HomeApp) structure/naming.
 */
export function App() {
  return (
    <AppProviders onSignInReturn={returnAfterSignIn}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}

export default App;
